import { render, staticRenderFns } from "./article-net-zero2025.vue?vue&type=template&id=9a721a00&scoped=true&"
import script from "./article-net-zero2025.vue?vue&type=script&lang=js&"
export * from "./article-net-zero2025.vue?vue&type=script&lang=js&"
import style0 from "./article-net-zero2025.vue?vue&type=style&index=0&id=9a721a00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a721a00",
  null
  
)

export default component.exports